<template>
    <div class="import-form">
        <a-steps v-model="current" type="navigation" size="small" class="import-steps">
            <a-step
                v-if="!skipPlatformSelection"
                title="Platform Seçimi"
                description="Kişiler nerede kullanılacak?"
                :status="current === 0 ? 'process' : 'wait'"
            />
            <a-step
                title="Dosya Seçimi"
                description="CSV veya Excel dosyası seçin"
                :status="
                    skipPlatformSelection ? (current === 0 ? 'process' : 'wait') : current === 1 ? 'process' : 'wait'
                "
            />
            <a-step
                title="İçe Aktarma Ayarları"
                description="Dosyanızı özelleştirin"
                :status="
                    skipPlatformSelection ? (current === 1 ? 'process' : 'wait') : current === 2 ? 'process' : 'wait'
                "
            />
        </a-steps>

        <div class="import-card">
            <div v-if="current === 0 && !skipPlatformSelection" class="platformSelection">
                <h3>Platform Seçimi</h3>
                <div class="platform-options">
                    <div
                        class="platform-option"
                        :class="{ selected: selectedPlatform === 'supsis' }"
                        @click="setPlatform('supsis')"
                    >
                        <div class="platform-icon">
                            <DynamicSvg name="CSupsis" />
                        </div>
                        <div class="platform-name">Supsis</div>
                    </div>
                    <div
                        class="platform-option"
                        :class="{ selected: selectedPlatform === 'email' }"
                        @click="setPlatform('email')"
                    >
                        <div class="platform-icon">
                            <DynamicSvg name="Mail" />
                        </div>
                        <div class="platform-name">Mail</div>
                    </div>
                    <div
                        class="platform-option"
                        :class="{ selected: selectedPlatform === 'whatsapp' }"
                        @click="setPlatform('whatsapp')"
                    >
                        <div class="platform-icon">
                            <DynamicSvg name="Whatsapp" />
                        </div>
                        <div class="platform-name">Whatsapp</div>
                    </div>
                </div>

                <div v-if="selectedPlatform === 'whatsapp' && whatsappChannels.length > 0" class="channel-selection">
                    <h4>Kanal Seçimi</h4>
                    <a-select v-model="selectedChannels" style="width: 100%" mode="multiple">
                        <a-select-option v-for="channel in whatsappChannels" :key="channel._id" :value="channel._id">
                            {{ channel.name }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="form-action">
                    <a-button @click="onCancelled">İptal</a-button>
                    <a-button type="primary" @click="goToNextStep" :disabled="!canProceed">İleri</a-button>
                </div>
            </div>

            <div
                v-if="(current === 1 && !skipPlatformSelection) || (current === 0 && skipPlatformSelection)"
                class="file-selection"
            >
                <h3>Dosya Seçimi</h3>
                <div class="file-box" @click="openSelectFile">
                    <div class="">
                        <a-icon type="file-excel" style="font-size: 50px; color: #08c" />
                    </div>
                    <div class="file-details">
                        <span v-if="file">{{ file.name }}</span>
                        <span v-else>Dosya Seçin</span>
                        <span>CSV veya Excel Dosyası</span>
                    </div>
                </div>
                <div class="form-action">
                    <a-button @click="current === 0 ? onCancelled : current--"
                        >{{ current === 0 ? "İptal" : "Geri" }}
                    </a-button>
                    <a-button type="primary" @click="goToNextStep" :disabled="!file">İleri</a-button>
                </div>
            </div>

            <div
                v-if="(current === 2 && !skipPlatformSelection) || (current === 1 && skipPlatformSelection)"
                class="file-configuration"
            >
                <h3>İçe Aktarma Ayarları</h3>
                <div class="config-content">
                    <div class="config-left">
                        <section class="config-section general-section">
                            <h4>Genel Ayarlar</h4>
                            <div class="general-options">
                                <div class="option-field">
                                    <label>İlk satırda başlık var mı?</label>
                                    <a-switch v-model="firstRowContainsHeader" />
                                </div>

                                <div class="option-field" v-if="!excelMode">
                                    <label>Ayırıcı Karakter</label>
                                    <a-select v-model="separator">
                                        <a-select-option value=",">Virgül (,)</a-select-option>
                                        <a-select-option value=";">Noktalı Virgül (;)</a-select-option>
                                    </a-select>
                                </div>
                            </div>
                        </section>

                        <section class="config-section fields-section">
                            <h4>Alan Eşleştirme</h4>
                            <div class="fields-header">
                                <div>SUPSIS ALANI</div>
                                <div></div>
                                <div>KAYNAK</div>
                            </div>
                            <div class="fields-container">
                                <div class="field-row" :key="field" v-for="field of Object.keys(mapping)">
                                    <div class="field-item">
                                        <a-select
                                            :options="getSelectOptionsForFields()"
                                            :value="field"
                                            :disabled="true"
                                        />
                                    </div>
                                    <div class="field-arrow">
                                        <i class="material-icons">arrow_forward</i>
                                    </div>
                                    <div class="field-item">
                                        <a-radio-group
                                            :value="mappingTypes[field]"
                                            @change="(e) => onMappingTypeChange(field, e.target.value)"
                                            style="display: flex; gap: 5px; margin-bottom: 5px"
                                        >
                                            <a-radio-button value="column">Sütun</a-radio-button>
                                            <a-radio-button value="static">Sabit Değer</a-radio-button>
                                        </a-radio-group>
                                        <a-select
                                            v-if="mappingTypes[field] === 'column'"
                                            :value="mapping[field]"
                                            @change="(value) => changeFieldValue(field, value)"
                                        >
                                            <a-select-option
                                                v-for="option in getSelectOptionsForColumns()"
                                                :key="option.value"
                                                :value="option.value"
                                            >
                                                {{ option.label }}
                                            </a-select-option>
                                            <a-select-option value="">Boş</a-select-option>
                                        </a-select>
                                        <a-input
                                            v-else
                                            :value="staticValues[field]"
                                            @change="(e) => changeStaticValue(field, e.target.value)"
                                            placeholder="Sabit değer girin"
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="config-section advanced-section">
                            <a-collapse>
                                <a-collapse-panel key="1" header="Gelişmiş Ayarlar">
                                    <div class="advanced-options">
                                        <div class="advanced-field">
                                            <label>Etiketler</label>
                                            <CustomPicker
                                                v-model="advancedSettings.tags"
                                                :items="tags"
                                                id-key="_id"
                                                label-key="name"
                                                title="Etiket Seçin"
                                                icon="label"
                                                :multiple="true"
                                            />
                                            <small>Oluşturulacak kişilere eklenecek etiketler</small>
                                        </div>

                                        <div class="advanced-field">
                                            <label>Departmanlar</label>
                                            <CustomPicker
                                                v-model="advancedSettings.relatedDepartments"
                                                :items="getDepartmentItems()"
                                                id-key="_id"
                                                label-key="name"
                                                title="Departman Seçin"
                                                icon="business"
                                                :multiple="true"
                                            />
                                            <small>Kişilerin ilişkilendirileceği departmanlar</small>
                                        </div>

                                        <div class="advanced-field">
                                            <label>Tercih Edilen Temsilciler</label>
                                            <CustomPicker
                                                v-model="advancedSettings.preferredAgents"
                                                :items="users"
                                                id-key="_id"
                                                label-key="name"
                                                title="Temsilci Seçin"
                                                icon="support_agent"
                                                :multiple="true"
                                            />
                                            <small>Kişilere atanacak tercih edilen temsilciler</small>
                                        </div>

                                        <div class="advanced-field">
                                            <label>Sahiplik</label>
                                            <CustomPicker
                                                v-model="advancedSettings.owner"
                                                :items="users"
                                                id-key="_id"
                                                label-key="name"
                                                title="Sahip Seçin"
                                                icon="assignment_ind"
                                                :multiple="false"
                                            />
                                            <small>Kişilere sahiplik atanacak mı?</small>
                                        </div>

                                        <div class="advanced-field vip-field">
                                            <div class="field-with-switch">
                                                <div class="field-label-group">
                                                    <label>VIP Müşteri</label>
                                                    <small>Kişiler VIP olarak işaretlensin mi?</small>
                                                </div>
                                                <a-switch v-model="advancedSettings.vipCustomer" />
                                            </div>
                                        </div>

                                        <div class="advanced-field">
                                            <label>Not</label>
                                            <small>Tüm kişilere eklenecek not</small>
                                            <a-textarea
                                                v-model="advancedSettings.note"
                                                :rows="4"
                                                placeholder="Kişilere eklenecek notu buraya yazın"
                                            />
                                        </div>
                                    </div>
                                </a-collapse-panel>
                            </a-collapse>
                        </section>
                    </div>
                    <div class="config-right">
                        <section class="config-section preview-section">
                            <h4>Önizleme</h4>
                            <div class="preview-table">
                                <ve-table
                                    :columns="getTableDataSource().columns"
                                    :table-data="getTableDataSource().rows"
                                    :row-style-option="rowStyleOption"
                                    :border-x="true"
                                    :border-y="true"
                                    row-key-field-name="phone"
                                    id="import-preview-table"
                                    :fixed-header="true"
                                />
                            </div>
                        </section>
                    </div>
                </div>
                <div class="form-action">
                    <a-button @click="current--">Geri</a-button>
                    <a-button type="primary" @click="importContacts" :loading="importing">
                        {{ importing ? "İçe Aktarılıyor..." : "Kişileri İçe Aktar" }}
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../utils/log2";
import { generateRandomId } from "../../../../utils/session";
import _ from "lodash";
import readXlsxFile from "read-excel-file";
import { mapState } from "vuex";
import StringUtils from "../../../../utils/StringUtils";
import { VeLocale } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import DynamicSvg from "../../../../components/DynamicSvg.vue";
import CustomPicker from "../../../../components/pickers/CustomPicker.vue";

VeLocale.use(enUS);

const log = log2("ImportContacts");
export default {
    name: "ImportContacts",
    components: {
        DynamicSvg,
        CustomPicker,
    },
    props: {
        onCancelled: {
            type: Function,
            required: true,
        },
        skipPlatformSelection: {
            type: Boolean,
            default: false,
        },
        defaultPlatform: {
            type: String,
            default: "supsis",
        },
    },
    data() {
        return {
            rowStyleOption: {
                stripe: true,
            },
            current: 0,
            file: null,
            headers: [],
            firstRowContainsHeader: true,
            separator: ",",
            fileText: "",
            excelMode: false,
            importing: false,
            mapping: {
                phone: "",
                name: "",
                email: "",
            },
            mappingTypes: {
                phone: "column",
                name: "column",
                email: "column",
            },
            staticValues: {
                phone: "",
                name: "",
                email: "",
            },
            advancedSettings: {
                tags: [],
                relatedDepartments: [],
                preferredAgents: [],
                owner: null,
                vipCustomer: false,
                note: "",
            },
            StringUtils,
            tableKey: 1,
            selectedPlatform: this.defaultPlatform || "supsis",
            selectedChannels: [],
            importStatus: null,
            importJobId: null,
        };
    },
    computed: {
        ...mapState({
            contactProperties: (state) => state.contactProperty.data,
            channels: (state) => state.channel.channels,
            siteId: (state) => state.auth.site._id,
            users: (state) => state.user.users.data,
            tags: (state) => state.tag.tags.data,
            departments: (state) => state.subject.subjects.data,
        }),

        whatsappChannels() {
            return this.channels.filter(
                (channel) =>
                    channel.type === "whatsapp-qr" ||
                    channel.type === "whatsapp-v2" ||
                    channel.type === "whatsapp-unipile" ||
                    channel.type === "whatsapp-business-api" ||
                    channel.type === "whatsapp-business-api-supsis"
            );
        },
        canProceed() {
            if (this.selectedPlatform === "whatsapp") {
                return !!this.selectedChannels.length;
            }
            return !!this.selectedPlatform;
        },
    },
    created() {
        this.mapping = this.contactProperties.reduce((acc, x) => {
            acc[x._id] = "";
            return acc;
        }, this.mapping);

        this.mappingTypes = this.contactProperties.reduce((acc, x) => {
            acc[x._id] = "column";
            return acc;
        }, this.mappingTypes);

        this.staticValues = this.contactProperties.reduce((acc, x) => {
            acc[x._id] = "";
            return acc;
        }, this.staticValues);

        if (this.selectedPlatform === "whatsapp" && !this.selectedChannels.length && this.whatsappChannels.length > 0) {
            this.selectedChannels = [this.whatsappChannels[0]._id];
        }
    },

    methods: {
        getDepartmentItems() {
            return this.departments.map((dept) => ({
                _id: dept._id,
                name:
                    _.get(dept, `languageContent.${this.$i18n.locale}.name`) ||
                    _.get(dept, `languageContent.${Object.keys(dept.languageContent)[0]}.name`) ||
                    dept.name,
            }));
        },
        setPlatform(platform) {
            this.selectedPlatform = platform;
            if (platform === "whatsapp" && !this.selectedChannels.length && this.whatsappChannels.length > 0) {
                this.selectedChannels = [this.whatsappChannels[0]._id];
            }
        },
        clearPhoneNumber(text) {
            return (text || "").toString().replace(/[^0-9]/g, "");
        },
        goToNextStep() {
            this.current++;
        },
        importContacts() {
            this.importing = true;
            const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

            const contacts = lines.map((line) => {
                const values = this.excelMode ? line : line.split(this.separator);
                const contact = {
                    phone:
                        this.mappingTypes.phone === "static"
                            ? this.clearPhoneNumber(this.staticValues.phone)
                            : this.clearPhoneNumber(
                                  values[this.headers.findIndex((x) => x.uniqueId === this.mapping.phone)]
                              ),
                    name:
                        this.mappingTypes.name === "static"
                            ? this.staticValues.name
                            : values[this.headers.findIndex((x) => x.uniqueId === this.mapping.name)],
                    email:
                        this.mappingTypes.email === "static"
                            ? this.staticValues.email
                            : values[this.headers.findIndex((x) => x.uniqueId === this.mapping.email)],
                    contactProperties: this.contactProperties.reduce((acc, x) => {
                        if (this.mappingTypes[x._id] === "static") {
                            if (this.staticValues[x._id]) {
                                acc[x.name] = this.staticValues[x._id];
                            }
                        } else {
                            const index = this.headers.findIndex((y) => y.uniqueId === this.mapping[x._id]);
                            if (index >= 0) {
                                acc[x.name] = values[index];
                            }
                        }
                        return acc;
                    }, {}),
                };
                return contact;
            });

            this.$emit("importContacts", {
                contacts: contacts,
                platform: this.selectedPlatform,
                channels: this.selectedChannels,
                total: contacts.length,
                advancedSettings: this.advancedSettings,
            });
        },
        changeFieldValue(field, value) {
            this.mapping[field] = value;
        },
        changeStaticValue(field, value) {
            this.staticValues[field] = value;
            this.staticValues = _.cloneDeep(this.staticValues);
        },
        onMappingTypeChange(field, newValue) {
            this.mappingTypes[field] = newValue;
            this.mappingTypes = _.cloneDeep(this.mappingTypes);

            if (newValue === "static") {
                this.mapping[field] = "";
                this.mapping = _.cloneDeep(this.mapping);
            } else {
                this.staticValues[field] = "";
                this.staticValues = _.cloneDeep(this.staticValues);
            }
        },
        getSelectOptionsForColumns() {
            return this.headers.map((header) => {
                return {
                    label: header.name,
                    value: header.uniqueId,
                };
            });
        },
        getSelectOptionsForFields() {
            return [
                {
                    label: "Email",
                    value: "email",
                },
                {
                    label: "Ad Soyad",
                    value: "name",
                },
                {
                    label: "Telefon",
                    value: "phone",
                },
                ...this.contactProperties.map((x) => ({
                    label: x.label,
                    value: x._id,
                })),
            ];
        },
        openSelectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute(
                "accept",
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            );
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                log("selected file", file);
                const isExcel = !file.type.includes("text/csv");
                if (file) {
                    this.file = file;
                    log(file);
                    if (isExcel) {
                        readXlsxFile(file).then((rows) => {
                            this.lines = rows;
                            this.parseExcel(rows);
                            this.excelMode = true;
                            this.goToNextStep();
                        });
                    } else {
                        const text = await this.file.text();
                        this.fileText = text;
                        this.parseCSVText(text);
                        this.goToNextStep();
                        this.excelMode = false;
                    }
                } else {
                    this.file = null;
                }
            };
            fileEl.click();
        },
        toVariableName(name) {
            return (name || "")
                .toString()
                .trim()
                .toLowerCase()
                .split(" ")
                .map((x) => x.trim().replace(/[^a-z0-9_]/g, ""))
                .filter((x) => x.length > 0)
                .join("-");
        },
        parseCSVText(text) {
            let lines = text.split("\n");
            let result = [];
            this.headers = [];
            this.headers = lines[0].split(this.separator).map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Sütun ${index + 1}`;
                const id = this.toVariableName(_name);
                const uniqueId = generateRandomId(4);
                if (index === 0 && this.mappingTypes.phone === "column") {
                    this.mapping.phone = uniqueId;
                } else if (index === 1 && this.mappingTypes.name === "column") {
                    this.mapping.name = uniqueId;
                } else if (index === 2 && this.mappingTypes.email === "column") {
                    this.mapping.email = uniqueId;
                }
                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            this.lines = lines;
            this.mapping = _.cloneDeep(this.mapping);
            this.tableKey = StringUtils.hashCodeObj(this.mapping);
        },
        parseExcel(lines) {
            this.headers = [];
            this.headers = lines[0].map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Sütun-${index + 1}`;
                const id = this.toVariableName(_name);
                const uniqueId = generateRandomId(4);
                if (index === 0 && this.mappingTypes.phone === "column") {
                    this.mapping.phone = uniqueId;
                } else if (index === 1 && this.mappingTypes.name === "column") {
                    this.mapping.name = uniqueId;
                } else if (index === 2 && this.mappingTypes.email === "column") {
                    this.mapping.email = uniqueId;
                }

                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            this.lines = lines;
            this.mapping = _.cloneDeep(this.mapping);
            this.tableKey = StringUtils.hashCodeObj(this.mapping);
        },
        getTableDataSource() {
            const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

            const colLabels = {
                email: "Email",
                name: "Ad Soyad",
                phone: "Telefon",
                ...this.contactProperties.reduce((acc, x) => {
                    acc[x._id] = x.label;
                    return acc;
                }, {}),
            };

            const columns = _.orderBy(
                Object.keys(this.mapping)
                    .filter((field) => {
                        if (this.mappingTypes[field] === "static") {
                            return (this.staticValues[field] || "").length > 0;
                        }
                        return (this.mapping[field] || "").length > 0;
                    })
                    .map((field, index) => {
                        const isStatic = this.mappingTypes[field] === "static";
                        return {
                            dataIndex: isStatic ? `static-${field}` : `${index}-${this.mapping[field]}`,
                            priority: ["phone", "name", "email"].indexOf(field),
                            headerIndex: isStatic
                                ? -1
                                : this.headers.findIndex((x) => x.uniqueId === this.mapping[field]),
                            field: isStatic ? `static-${field}` : `${index}-${this.mapping[field]}`,
                            dataField: field,
                            key: isStatic ? `static-${field}` : `${index}-${this.mapping[field]}`,
                            title: colLabels[field],
                            align: "left",
                            isStatic,
                        };
                    }),
                ["priority"],
                ["desc"]
            );

            const rows = _.take(lines, 5).map((line) => {
                const values = this.excelMode ? line : line.split(this.separator);
                const row = {};
                columns.forEach((col) => {
                    if (col.isStatic) {
                        row[`${col.key}`] = this.staticValues[col.dataField];
                    } else {
                        row[`${col.key}`] = values[col.headerIndex];
                    }
                });
                return row;
            });

            return {
                columns,
                rows,
            };
        },
    },
    watch: {
        separator() {
            if (!this.excelMode) this.parseCSVText(this.fileText);
        },
        firstRowContainsHeader() {
            if (this.excelMode) this.parseExcel(this.lines);
            else this.parseCSVText(this.fileText);
        },
    },
};
</script>

<style lang="scss">
.import-form {
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;

    .import-steps {
        margin-bottom: 24px;
    }

    .import-card {
        h3 {
            color: #1890ff;
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 24px;
            border-bottom: 2px solid #f0f0f0;
            padding-bottom: 12px;
        }

        h4 {
            color: #333;
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 16px;
        }
    }

    .form-action {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #f0f0f0;
        width: 100%;
        gap: 10px;

        button {
            padding: 0 24px;
            height: 38px;
            font-size: 14px;
            border-radius: 6px;
            transition: all 0.3s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }
        }

        button[type="primary"] {
            background: #1890ff;
            min-width: 160px;

            &:hover {
                background: #40a9ff;
                box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
            }
        }
    }

    .platformSelection {
        .platform-options {
            display: flex;
            gap: 24px;
            margin-bottom: 30px;
            justify-content: center;

            .platform-option {
                width: 140px;
                height: 140px;
                border: 1px solid #e8e8e8;
                border-radius: 12px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

                &:hover {
                    background-color: #f5f5f5;
                    transform: translateY(-3px);
                }

                &.selected {
                    border-color: #1890ff;
                    background-color: #e6f7ff;
                    transform: translateY(-3px);
                    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);

                    .platform-icon {
                        color: #1890ff;
                    }
                }

                .platform-icon {
                    width: 60px;
                    height: 60px;
                    font-size: 48px;
                    margin-bottom: 16px;

                    svg {
                        width: 100%;
                        height: 100%;
                    }

                    i {
                        font-size: 48px;
                    }
                }

                .platform-name {
                    font-size: 16px;
                    font-weight: 500;
                }
            }
        }

        .channel-selection {
            margin-bottom: 20px;
            max-width: 400px;

            h4 {
                margin-bottom: 12px;
            }

            .ant-select {
                border-radius: 6px;

                &:hover {
                    border-color: #40a9ff;
                }
            }
        }
    }

    .file-selection {
        display: flex;
        flex-direction: column;

        .file-box {
            width: 100%;
            max-width: 400px;
            height: 220px;
            border: 2px dashed #d9d9d9;
            border-radius: 12px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #fafafa;
            transition: all 0.3s ease;
            margin: 0 auto;

            &:hover {
                background: #f0f0f0;
                border-color: #1890ff;
                transform: translateY(-3px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .file-details {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
                margin-top: 20px;
                text-align: center;

                span:first-child {
                    font-weight: 600;
                    font-size: 16px;
                }

                span:last-child {
                    color: #666;
                    font-size: 14px;
                }
            }
        }
    }

    .file-configuration {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .config-content {
            display: flex;
            gap: 30px;
            width: 100%;

            .config-left {
                width: 40%;
                display: flex;
                flex-direction: column;
                gap: 24px;
            }

            .config-right {
                width: 60%;
            }

            .config-section {
                background: #f9f9f9;
                border-radius: 8px;
                padding: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
            }

            .general-section {
                .general-options {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;

                    .option-field {
                        background: #ffffff;
                        padding: 16px;
                        border-radius: 8px;
                        min-width: 200px;
                        flex: 1;
                        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);

                        label {
                            display: block;
                            font-size: 14px;
                            color: #333;
                            font-weight: 600;
                            margin-bottom: 12px;
                        }

                        .ant-switch {
                            width: 44px;
                        }

                        .ant-select {
                            width: 100%;
                        }
                    }
                }
            }

            .fields-section {
                .fields-header {
                    display: grid;
                    grid-template-columns: 1fr 50px 1fr;
                    gap: 8px;
                    margin-bottom: 12px;
                    background: #e6f7ff;
                    padding: 10px 15px;
                    border-radius: 6px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                }

                .fields-container {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;

                    .field-row {
                        display: grid;
                        grid-template-columns: 1fr 50px 1fr;
                        gap: 8px;
                        align-items: center;
                        background: #ffffff;
                        padding: 12px 15px;
                        border-radius: 6px;
                        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
                        transition: all 0.3s ease;

                        &:hover {
                            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
                            transform: translateY(-2px);
                        }

                        .field-arrow {
                            display: flex;
                            justify-content: center;

                            i.material-icons {
                                color: #1890ff;
                            }
                        }

                        .field-item {
                            width: 100%;
                            .ant-select {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            .preview-section {
                height: 100%;
                display: flex;
                flex-direction: column;

                .preview-table {
                    flex: 1;
                    border-radius: 8px;
                    overflow: hidden;
                    border: 1px solid #f0f0f0;
                    margin-top: 10px;

                    .ve-table {
                        max-height: 400px;

                        th {
                            background-color: #f5f7fa !important;
                            font-weight: 600;
                            color: #333;
                        }

                        tr:hover td {
                            background-color: #e6f7ff;
                        }
                    }
                }
            }

            .advanced-section {
                margin-top: 20px;

                .advanced-options {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    padding: 10px 0;

                    .advanced-field {
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        .supsis-button {
                            min-width: 300px;
                            align-items: center;
                            justify-content: space-between;
                        }

                        label {
                            font-weight: 600;
                            color: #333;
                            font-size: 14px;
                        }

                        small {
                            color: #666;
                            font-size: 12px;
                            margin-top: 4px;
                            display: block;
                        }

                        &.vip-field {
                            .field-with-switch {
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding: 12px 16px;
                                background: #f9f9f9;
                                border-radius: 8px;
                                border: 1px solid #e8e8e8;

                                .field-label-group {
                                    display: flex;
                                    flex-direction: column;
                                    gap: 4px;

                                    label {
                                        margin: 0;
                                    }

                                    small {
                                        margin: 0;
                                    }
                                }

                                .ant-switch {
                                    width: 44px;
                                }
                            }
                        }

                        .ant-textarea {
                            border-radius: 6px;

                            &:hover {
                                border-color: #40a9ff;
                            }

                            &:focus {
                                border-color: #1890ff;
                                box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
